import React from 'react'
import ConstantsUtil from '../../../context/constantsUtil'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import DialogFooter from '../../dialogFooter'
import GeneralServices from '../../../app/service/generalServices'
import * as popUp from '../../toastr'
import HandleErrorService from '../../../app/service/handleErrorService'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import TooltipButton from '../../tooltipButton'
import TipoDeDescontoService from '../../../app/service/contasAPagar/tipoDeDescontoService'
import CustomHighlighter from '../../customHighlighter'

const cadastrarLabel = "Cadastrar Tipo De Desconto"

class InputChooseTipoDeDesconto extends React.Component {

    constructor()
    {
        super()
        this.generalServices = new GeneralServices()
        this.tipoDeDescontoService = new TipoDeDescontoService()
    }

    state = {

        tiposDeDescontoList: [],
        filteredTipoDeDescontoList: [],

        displayDialog: false,
        displayCreateOrEditDialog: false,

        idTipoDeDescontoToEdit: null,

        descricaoTipoDeDescontoASerCriadaOuEditada: '',
        inputDescricaoTipoDeDescontoASerCriadaOuEditadaErrorClass: '',

        selectedTipoDeDesconto: null,

        didUpdated: false,

        isEditDialog: false,

        searchText: '',
        
    }
    
    componentDidUpdate(){
        // console.log("update: ", this.state.didUpdated)
        if(this.state.displayDialog && !this.state.didUpdated){
            this.setState({isEditDialog: false})
            this.search()
        }
    }

    search = () => {
        // console.log("search")
        this.setState({didUpdated: true})
        this.setState({loadingTable: true})
        
        this.tipoDeDescontoService.search()
        .then(response => {
            this.setState({tiposDeDescontoList: response.data})
            this.setState({filteredTipoDeDescontoList: response.data})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loadingTable: false})
        })
    }

    resetView = () => {
        this.setState({
            inputDescricaoTipoDeDescontoServiceASerCriadaOuEditadaErrorClass: '',
        })
    }

    checkDataCadastro = () => {
        
        let check = true
        
        if(!this.state.descricaoTipoDeDescontoASerCriadaOuEditada){
            this.setState({inputDescricaoTipoDeDescontoServiceASerCriadaOuEditadaErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }

        return check

    }

    handleCreateOrEditTipoDeDesconto = (obj) => {
        return this.state.isEditDialog ? this.tipoDeDescontoService.edit(obj) : this.tipoDeDescontoService.save(obj)
    }

    callSaveCadastroTipoDeDesconto = () => {
        this.resetView()
        if(this.checkDataCadastro()){
            let obj = {
                id: this.state.idTipoDeDescontoToEdit,
                descricao: this.state.descricaoTipoDeDescontoASerCriadaOuEditada
            }
            this.handleCreateOrEditTipoDeDesconto(obj)
            .then(response => {
                popUp.successPopUp("Tipo De Desconto Cadastrada com Sucesso!")
                this.hideCreationDialog()
                this.search()
            })
            .catch(error => {
                HandleErrorService.handleError(error)
            })
        }
    }

    hideCreationDialog = () => {
        this.setState({
            idTipoDeDescontoToEdit: null,
            descricaoTipoDeDescontoASerCriadaOuEditada: '',
            isEditDialog: false,
            displayCreateOrEditDialog: false
        })
    }

    hideDialog = async () => {
        await this.setState({displayDialog: false})
        this.setState({didUpdated: false})
    }

    handleDescricaoChange = (event) => {
        const name = event.target.name
        const value = event.target.value
        this.setState({ [name]: value })
    }

    handleKeyPress = async (e) => {
        if (e.key === "Enter") {
            this.inputClick()
          }
    }

    handleSelectionChange = async (event) => {

        let value = event.value

        await this.generalServices.sleep(100)
        if(
            this.state.selectedTipoDeDesconto && value === null
            && !this.state.displayCreateOrEditDialog
        ){
            /*
            Significa que clicou em cima do item que estava selecionado antes (double click), por isso ficou null.
            // Mas, se preocupa com o caso de esse 2° click ter sido em cima do botão de editar. Neste caso, não significa que selecinou.
            */
            this.selectTipoDeDesconto()
        } else{
            this.setState({selectedTipoDeDesconto: value})
        }

    }

    selectTipoDeDesconto = () => {
        this.props.handleSelectionChange(this.state.selectedTipoDeDesconto)
        this.hideDialog()
    }

    inputClick = () => {
        if(!this.props.disabled){
            this.setState({displayDialog: true})
        }
    }

    edit = async (selectedTipoDeDesconto) => {
        this.setState({
            idTipoDeDescontoToEdit: selectedTipoDeDesconto.id,
            descricaoTipoDeDescontoASerCriadaOuEditada: selectedTipoDeDesconto.descricao,
            isEditDialog: true,
            displayCreateOrEditDialog: true
        })
    }

    handleKeyPressBusca = async (e) => {
        if (e.key === "Enter") {
            const filteredList = JSON.parse(JSON.stringify(this.state.filteredTipoDeDescontoList))
            if(filteredList.length === 1){
                await this.setState({selectedTipoDeDesconto: filteredList[0]})
                this.selectTipoDeDesconto()
            }
          }        
    }

    handleSearchTextChange = async (event) => {
        const value = event.target.value
        const name = event.target.name
        await this.setState({ [name]: value })
        this.filter()
    }
    
    filter  = () => {
        
        this.setState({
            filteredTipoDeDescontoList:
                JSON.parse(
                    JSON.stringify(
                        this.state.tiposDeDescontoList.filter(tiposDeDesconto => {
                            return (
                                GeneralServices.includeString(tiposDeDesconto.descricao, this.state.searchText)
                            )
                        }
                        )
                    )
                )
        })
    }   

    render(){

        const renderInput = () => {
            
            return (
                <>
                <label>Tipo De Desconto</label>
                <div className='row'>
                <div className='col-md-12'>
                    <input 
                        type="text"
                        className={"form-control " + this.props.inputErrorClass}
                        readOnly
                        value = {this.props.selectedTipoDeDescontoLabel}
                        placeholder="Selecione..."
                        onClick={this.inputClick}
                        onKeyDown={this.handleKeyPress}
                        disabled={this.props.disabled}
                    />
                    <div className="invalid-feedback">Selecione o Tipo de Desconto</div>
                    </div>
                </div>
                </>
            )
        }

        const renderHTMLFormat = () => {
            if(this.props.noHTMLFormat){
                return (
                    <>
                    {renderInput()}
                    </>
                )
            }
            else {
                return (
                    <>
                    <div className="row">
                    <div className="col-md-12">
                    {renderInput()}
                    </div>
                    </div>
                    </>
                )
            }
        }

        const actionBody = (selectedTipoDeDesconto) => {
            return (
                <React.Fragment>
                    <TooltipButton
                        tooltip = "Editar Tipo De Desconto"
                        icon={<i className="pi pi-pencil" style={{fontSize: '1em'}}></i>}
                        onClick={() => this.edit(selectedTipoDeDesconto)}
                        style={ {maxHeight: '25px', maxWidth: '25px'} }
                    />
                </React.Fragment>
            );
        }

        const renderTable = () => {

            return (

                <DataTable
                    ref={this.dt}
                    value={this.state.filteredTipoDeDescontoList}
                    searchText={this.state.searchText}
                    className="p-datatable-sm small-font"
                    rowHover
                    emptyMessage="Não há tipos de desconto cadastrados."
                    showGridlines
                    selection={this.state.selectedTipoDeDesconto}
                    onSelectionChange={this.handleSelectionChange}
                    loading={this.state.loadingTable}
                    dataKey="id"
                >

                    <Column selectionMode="single" headerStyle={{ width: '3rem' }} />

                    <Column
                        header="Descrição"
                        field="descricao"
                        sortable
                        style ={ {width: '200px'} }
                        body={rowData => 
                            <CustomHighlighter
                                searchWords={[this.state.searchText]}
                                textToHighlight={rowData.descricao}
                            />
                        }                        
                    />

                    <Column
                        header="Fixo do Sistema"
                        field="fixoSistema"
                        sortable
                        style ={ {width: '200px'} }
                        body={rowData => rowData.fixoSistema ? 'Sim' : 'Não'}                        
                    />

                    <Column header="Editar" body={actionBody} style ={ {width: '140px'} } />

                </DataTable>

            )
        }

        const renderDialog = () => {

            return (
                <Dialog
                    header={"Tipo De Desconto"}
                    visible={this.state.displayDialog}
                    modal
                    style={{ width: '90vw' }}
                    footer={dialogFooter(this.selectTipoDeDesconto, this.hideDialog)}
                    onHide={this.hideDialog}
                >

                    <div className="p-field">
                        <label htmlFor="search conta">Busca</label>
                        <input
                            autoFocus   
                            className={"form-control " }
                            type="text"
                            id="searchText"
                            name="searchText"
                            value={this.state.searchText}
                            placeholder="Pesquise pela descrição"
                            onChange={this.handleSearchTextChange}
                            onKeyDown={this.handleKeyPressBusca}
                        />
                    </div>

                    <br />

                    <Button
                        label={cadastrarLabel}
                        icon="pi pi-plus"
                        className=" small-font"
                        style={{maxHeight: '25px', marginLeft: '10px'}}
                        onClick={() => this.setState({displayCreateOrEditDialog: true})}
                    />

                    <br />
                    <br />

                    {renderTable()}

                </Dialog>

            )

        }

        const dialogFooter = (callSaveFunction, hideDialogFunction) => {
            return (
                <DialogFooter save = {callSaveFunction} hideDialog = {hideDialogFunction}/>
            )
        } 

        const renderCreationDialog = () => {

            return (

                <Dialog
                    header={ this.state.isEditDialog ? "Editar Tipo De Desconto" : cadastrarLabel}
                    visible={this.state.displayCreateOrEditDialog}
                    modal = {true}
                    className="p-fluid"
                    style={{ width: '30%' }}
                    footer={dialogFooter(this.callSaveCadastroTipoDeDesconto, this.hideCreationDialog)}
                    onHide={this.hideCreationDialog}
                >
                    <div className="p-field">
                        <label>Descrição</label>
                        <input
                            type="text"
                            autoFocus
                            name="descricaoTipoDeDescontoASerCriadaOuEditada"
                            className={"form-control " + this.state.inputDescricaoTipoDeDescontoASerCriadaOuEditadaErrorClass}
                            value = {this.state.descricaoTipoDeDescontoASerCriadaOuEditada}
                            onChange={this.handleDescricaoChange}
                            // onKeyDown={this.callSaveCadastroTipoDeDesconto}
                            onKeyDown={e => e.key === 'Enter' && this.callSaveCadastroTipoDeDesconto()}
                        />    
                        <div className="invalid-feedback">{"Informe a descrição"}</div>
                    </div>

                </Dialog>

            )

        }

        return(
            <>
            
                {renderHTMLFormat()}

                {renderDialog()}

                {renderCreationDialog()}
                
            </>
        )

    }


}

export default InputChooseTipoDeDesconto